import React from 'react';
import { usePublicSettings } from '../../hooks/usePublicSettings';
import { useClubTheme } from '../../contexts/ClubThemeContext';
import { assetUrl } from '../../utils/url';
import { useTranslation } from 'react-i18next';

export type ClubHeroTopbarVariant = 'brand' | 'minimal' | 'badge';

const cls = (...parts: Array<string | false | null | undefined>) => parts.filter(Boolean).join(' ');

const ClubHeroTopbar: React.FC<{ variant?: ClubHeroTopbarVariant; fullBleed?: boolean }>= ({ variant = 'minimal', fullBleed = false }) => {
  const { t } = useTranslation();
  const { data: settings } = usePublicSettings();
  const theme = useClubTheme();
  const title = settings?.club_name || theme.name || 'Fotbalový klub';
  const tagline = t('homepage.official_website');
  const logo = assetUrl(settings?.club_logo_url || theme.logoUrl) || settings?.club_logo_url || theme.logoUrl || '/dist/img/logo-club-empty.svg';
  const shopUrl = settings?.shop_url || undefined;
  const calendarUrl = '/kalendar';

  return (
    <div className={cls('club-hero-topbar', fullBleed && 'full-bleed',
      variant === 'brand' && 'club-hero-topbar--brand',
      variant === 'minimal' && 'club-hero-topbar--minimal',
      variant === 'badge' && 'club-hero-topbar--badge'
    )}>
      <div className="club-hero-topbar__logo">
        {/* eslint-disable-next-line jsx-a11y/alt-text */}
        <img src={logo} alt={title} style={{ width: 36, height: 36, objectFit: 'contain' }} />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div className="club-hero-topbar__title">{title}</div>
        <div className="club-hero-topbar__tagline">{tagline}</div>
      </div>
      <div className="club-hero-topbar__spacer" />
      {variant !== 'minimal' && (
        <div className="club-hero-topbar__actions">
          <a href={calendarUrl} className="sparta-button-tertiary">Kalendář</a>
          {shopUrl && (
            <a href={shopUrl} target="_blank" rel="noreferrer" className="sparta-button-primary">Fanshop</a>
          )}
        </div>
      )}
    </div>
  );
};

export default ClubHeroTopbar;
